import { createUseStyles } from "react-jss";

export default createUseStyles({
    navigation: {
        bottom: 0,
        composes: "navigation",
        left: 0,
        margin: ({ theme }) =>
            theme.BottomNavigationPosition === "floating" ? [[0, 0]] : [[29, -6]],
        position: ({ theme }) => theme.BottomNavigationPosition === "floating" && "fixed",
        right: 0,
    },
    navigationButtonContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        textAlign: "center",
        "& .button": {
            margin: ({ theme }) => theme.BottomNavigationPosition === "floating" && 0,
            borderRadius: ({ theme }) => theme.BottomNavigationPosition === "floating" && 0,
        },
    },
});
